import { experiment } from "@faire/web--source/common/settings/declarations/experiment";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
/**
 * Batch 7 Search Placeholder Test
 */ export var FE_BATCH_7_SEARCH_PLACEHOLDER_V2_250128 = experiment({
    name: "FE_BATCH_7_SEARCH_PLACEHOLDER_V2_250128",
    identifier: "SessionToken",
    client: "RETAILER",
    notifyAfter: "2025-03-01",
    defaultValue: IThreeVariantXP.Bucket.CONTROL,
    productArea: "LOGGED_OUT_RETAILERS"
});
